"use client";

import { FormattedMessage } from "react-intl";

/**
 * First focusable element of every site page: hidden until focused, it jumps keyboard
 * users past the promo banner and the navbar to `#main-content` (WCAG 2.4.1).
 */
export default function SkipLink() {
  return (
    <a href="#main-content" className="skip-link">
      <FormattedMessage id="a11y.skipToContent" />
    </a>
  );
}
